import {useEffect} from "react";
import CONFIG from "../Services/CONFIG";
import {useLocation, useNavigate} from 'react-router-dom';
import {useAuth} from "../Contexts/AuthContext";
import {MetaApiProvider, useMetaApi} from "../Services/MetaApiProvider";

function InstagramConnectionContent({canEdit}) {
    const { status } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const {metaConnection} = useMetaApi();

    useEffect(() => {
      const handleInstagramConnection = async () => {
        const params = new URLSearchParams(location.search);
        const code = params.get("code");
        const error = params.get("error");

        const redirectUri = CONFIG.INST_REDIRECT_URI;
        const channelId = localStorage.getItem("channelId");
        console.log("URL params:", params.toString());
        console.log("Channel ID:", channelId);

        const navigateWithAlert = (type, message) => {
          navigate(`/organizations/${status.organization_id}/channels/${channelId}`, {
            state: { type, message }
          });
        };

        if (code) {
          try {
            await metaConnection(code, redirectUri, channelId);
            console.log("Instagram connected successfully");
            navigateWithAlert("success", "Instagram connected successfully");
          } catch (err) {
            console.error("Error exchanging code:", err);
            navigateWithAlert("fail", "Failed to connect Instagram");
          }
        } else if (error) {
          console.log("Instagram authorization canceled or failed:", error);
          navigateWithAlert("fail", "Instagram authorization canceled");
        } else {
          console.log("No code or error received from Instagram");
          navigateWithAlert("fail", "No code or error received from Instagram");
        }
      };

      handleInstagramConnection();
    }, [metaConnection]);

return <div>Please wait...</div>;
}

function InstagramConnectionPage({canEdit}) {
    return (
        <MetaApiProvider>
            <InstagramConnectionContent canEdit={canEdit}/>
        </MetaApiProvider>
    );
}

export default InstagramConnectionPage;
